import PageLayout from "@/components/layout/PageLayout";
import FAQ from "@/components/sections/FAQ";
import TechSpecs from "@/components/sections/TechSpecs";

export default function FAQPage() {
  return (
    <PageLayout testId="faq-page">
      <FAQ />
      <TechSpecs />
    </PageLayout>
  );
}
